// Basic
import { useState } from 'react';
// Components
import { Tabs } from '@/common-utils/components/ui/tabs';
import Page from '@/common-utils/components/structure/page/Page';
import PageActions from '@/common-utils/components/renders/pageActions/PageActions';
import ModalDomiciliation from '@/app/modules/contracts/components/modals/ModalDomiciliation';
import SearchContractsTable from '@/app/modules/searchContracts/components/tables/SearchContractsTable';
// Common
import RouteUrls from '../enums/RouteUrls';
import ICONS from '@/common-utils/enums/icons';
import setFiltersEventName from '@/common-utils/components/renders/dataTable/utils/setFiltersEventName';
// Lang
import { nsSearchContract } from '@/app/i18n/namespaces';

/**
 * @returns {JSX} SearchContracts
 */
function SearchContracts() {

    // State
    const [showModalDomCard, setShowModalDomCard] = useState(false);

    return (
        <Page>
            <Tabs defaultValue='searchContracts'>
                <Page.Header
                    route={RouteUrls.SEARCH_CONTRACTS}
                    routeBase={RouteUrls.SEARCH_CONTRACTS}
                />
                <Page.Body dataCy='page-search-contracts'>
                    <>
                        <SearchContractsTable
                            filtersEventName={setFiltersEventName('search_contracts')}
                            pageActions={
                                <PageActions
                                    actions={[
                                        {
                                            icon: ICONS.CREDIT_CARD,
                                            entity: 'actions.page.dom_card',
                                            namespace: nsSearchContract,
                                            onClick: () => setShowModalDomCard(true),
                                            visible: true
                                        }
                                    ]}
                                    retractable
                                />
                            } />
                    </>
                </Page.Body>
            </Tabs>
            {
                showModalDomCard
                && <ModalDomiciliation
                    isCustomDomiciliation={true}
                    isOpen={showModalDomCard}
                    setIsOpen={setShowModalDomCard}
                />
            }
        </Page>
    );
}

export default SearchContracts;